import { Component, type ReactNode } from 'react';

/**
 * Garde-fou autour de ce que les nouveautés ajoutent aux écrans existants
 * (badge du menu, bandeau, modale d'arrivée) : si l'un d'eux plante au rendu, il
 * disparaît au lieu d'emporter le menu ou le layout avec lui. Une panne des
 * nouveautés ne doit jamais empêcher d'utiliser l'application.
 */
export class NewsSilentBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    console.error('[news] rendu abandonné', error);
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
